/**
 * Typed environment variable access
 */
export const env = {
  // Backend API base
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:3001',

  // Feature flags
  ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  ENABLE_ERROR_REPORTING: import.meta.env.VITE_ENABLE_ERROR_REPORTING === 'true',
  ENABLE_FEATURE_X: import.meta.env.VITE_ENABLE_FEATURE_X === 'true',

  // App environment (development | staging | production)
  APP_ENV: import.meta.env.VITE_APP_ENV || 'development',

  // Supabase
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,

  // Sentry error reporting
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,

  // N8N webhooks
  N8N_WEBHOOK_URL: import.meta.env.VITE_N8N_WEBHOOK_URL,
  N8N_SECRET: import.meta.env.VITE_N8N_SECRET,

  // Environment flags from Vite
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const;
